import { http } from '../../../../api/http';
import type { VentaDetalle, VentaCreateRequest } from '../types/venta.types';

export class VentaService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas',
  };

  public static async getById(id: number): Promise<VentaDetalle> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching venta:', error);
      throw error;
    }
  }

  public static async create(data: VentaCreateRequest): Promise<any> {
    try {
      const response = await http.post(this.ENDPOINTS.BASE, data);
      return response.data;
    } catch (error) {
      console.error('Error creating venta:', error);
      throw error;
    }
  }

  public static async update(id: number, data: VentaCreateRequest): Promise<any> {
    try {
      const response = await http.put(`${this.ENDPOINTS.BASE}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating venta:', error);
      throw error;
    }
  }

  public static async anular(id: number): Promise<boolean> {
    try {
      const response = await http.delete(`${this.ENDPOINTS.BASE}/${id}`);
      return response.status === 204;
    } catch (error) {
      console.error('Error anulando venta:', error);
      throw error;
    }
  }
}
